<template>
  <TextInput
    ref="searchInput"
    v-model="searchTerm"
    :placeholder="placeholder"
    size="sm"
    class="grow w-auto max-w-full dark:fg-white dark:placeholder:text-alpha-black-30 dark:border-none flex-shrink-0"
    :debounce-ms="500"
  >
    <template #start>
      <Icon name="search" class="fg-quaternary dark:text-alpha-black-60" />
    </template>
    <template #end>
      <Icon
        name="close"
        size="sm"
        class="cursor-pointer fg-quaternary dark:text-alpha-black-50"
        @click="emit('close')"
      />
    </template>
  </TextInput>
</template>

<script setup>
import { nextTick, onMounted, ref, watch, watchEffect } from "vue";
import { debounce } from "lodash";
import { Icon } from "@/SharedComponents/Icon";
import { TextInput } from "@/SharedComponents/Inputs";

const emit = defineEmits(["close", "search"]);

const props = defineProps({
  query: { type: String, default: "" },
  placeholder: { type: String, required: true },
});

const searchTerm = ref(props.query);

watchEffect(() => {
  searchTerm.value = props.query;
});

const onSearchTermChange = debounce((newSearchTerm) => {
  emit("search", newSearchTerm);
}, 200);

watch(searchTerm, () => {
  if (!searchTerm.value) {
    emit("search", "");
  }
  onSearchTermChange(searchTerm.value);
});

const searchInput = ref(null);

onMounted(() => {
  nextTick(() => {
    searchInput.value.focus();
  });
});

defineExpose({
  focus: () => searchInput.value?.focus(),
});
</script>
